import React, { useState, useEffect, useMemo, FC } from "react";
import {
  Image,
  Grid,
  Icon,
  Card,
  Placeholder,
  Transition,
  List,
  ListItem,
} from "semantic-ui-react";
import { YouTubePopularVideos } from "../../types/YouTube.types";
import { withCommas } from "../utils";

type VideoCardProps = {
  visible: boolean;
};

const VideoCard: FC<VideoCardProps> = ({ children, visible }) => (
  <Grid.Column mobile={15} computer={8}>
    <Transition
      transitionOnMount
      animation="scale"
      duration={500}
      visible={visible}
    >
      <Card centered fluid>
        {children}
      </Card>
    </Transition>
  </Grid.Column>
);
const PopularVideos = () => {
  const [popularVideos, setPopularVideos] = useState<YouTubePopularVideos>([]);
  const [showVideos, setShowVideos] = useState<boolean>(false);
  const getPopularVideos = async () => {
    const res = await fetch("/api/YouTube/getPopularVideos");
    const videos = await res.json();
    setPopularVideos(videos);
    setTimeout(() => {
      setShowVideos(true);
    }, 1000);
  };

  useEffect(() => {
    getPopularVideos();
  }, []);

  return (
    <>
      {showVideos
        ? popularVideos.map(
            ({ videoThumbnail, title, publishedAt, views, likes }) => (
              <VideoCard key={title || ""} visible={true}>
                <Image
                  rounded
                  fluid
                  src={videoThumbnail}
                  wrapped
                  ui={false}
                  size="large"
                />
                <Card.Content>
                  <Card.Header>{title}</Card.Header>
                </Card.Content>
                <Card.Content extra>
                  <Card.Description>
                    <List horizontal>
                      <ListItem>
                        <List.Content>
                          <Icon name="eye" />
                          {withCommas(views)}
                        </List.Content>
                      </ListItem>
                      <ListItem>
                        <List.Content>
                          <Icon name="thumbs up outline" />
                          {withCommas(likes)}
                        </List.Content>
                      </ListItem>
                    </List>

                    <List horizontal floated="right">
                      <ListItem style={{ float: "right" }}>
                        <List.Content>
                          <Icon name="calendar alternate outline" />
                          {
                            new Date(publishedAt || 0)
                              .toLocaleString()
                              .split(",")[0]
                          }
                        </List.Content>
                      </ListItem>
                    </List>
                  </Card.Description>
                </Card.Content>
              </VideoCard>
            )
          )
        : [1, 2, 3, 4, 5, 6].map((i) => (
            <VideoCard key={`${i}`} visible={popularVideos.length === 0}>
              <Placeholder inverted>
                <Placeholder.Image rectangular />
              </Placeholder>
            </VideoCard>
          ))}
    </>
  );
};

export default PopularVideos;
